"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const debug_1 = __importDefault(require("debug"));
const locale_codes_1 = __importDefault(require("locale-codes"));
const result_1 = require("../result");
const debug = debug_1.default('language-fallback');
// create the chain of language codes to be tried in the fallback mechanism
function localeFallbackChain(language) {
    let chain = [];
    const loc = locale_codes_1.default.getByTag(language);
    if (!loc) {
        debug(`Invalid language code '${language}'`);
        return chain;
    }
    chain.push(loc.tag);
    if (loc["iso639-1"]) {
        chain.push(loc["iso639-1"]);
    }
    if (loc["iso639-2"]) {
        chain.push(loc["iso639-2"]);
    }
    return chain;
}
exports.localeFallbackChain = localeFallbackChain;
// tries to resolve the callback with the fallback chain (async)
async function fallbackAsync(chain, callback) {
    debug(`fallback chain '${chain}'`);
    for (const code of chain) {
        debug(`trying to resolve with '${code}'`);
        let loaded = await callback(code);
        if (loaded.success) {
            debug(`success with '${code}'`);
            return loaded;
        }
    }
    debug(`could not resolve using neither of the items`);
    return result_1.err('not-found');
}
exports.fallbackAsync = fallbackAsync;
// tries to resolve the callback with the fallback chain (sync)
function fallback(chain, callback) {
    debug(`fallback chain '${chain}'`);
    for (const code of chain) {
        debug(`trying to resolve with '${code}'`);
        let loaded = callback(code);
        if (loaded.success) {
            debug(`success with '${code}'`);
            return loaded;
        }
    }
    debug(`could not resolve using neither of the items`);
    return result_1.err('not-found');
}
exports.fallback = fallback;
//# sourceMappingURL=locale-fallback.js.map